//Library Imports
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import store, { RootState } from 'store';

//Local imports
import { Row, Col, Popover, Typography, Select } from 'antd';
import KeywordSource from './KeywordSource';
import NewCampaignModule from './NewCampaignModule';
import Input from '../../../Common/Components/Input';
import DownAngle from '../../../../assets/img/icons/DownAngle.svg';
import Temp from '../../../../assets/img/template.svg';
import CustomSelectAsset from 'modules/Design/Assets/CustomSelectAsset';
import { ICampaignsName } from 'modules/Campaigns/interfaces';
import {
  dynamicAudienceSearch,
  getRecommendedLists,
  getRecommendedPeople,
  saveAIEmailAssetAPIAndCampaign,
  saveAdHocAssetAPI,
  saveAdHocAssetAPIAndCampaign,
  searchLists,
  searchPeople,
  setAiContacts,
  setInputPrompt,
} from '../actions';

//Style imports
import styled from 'styled-components';
import { ADHOC } from 'constants/types';
import { closeOverlay } from 'modules/GlobalActions';
import { AssetType, scrollbar } from 'modules/Campaigns/utils';
import CloseIconDrawer from 'assets/svgs/CloseIconDrawer';
import classNames from 'classnames';
import GillRoyBotIcon from 'assets/svgs/GillRoyBotIcon';
import FooterActionButton from './FooterActionButton';
import useAutosizeTextArea from './useAutosizeTextArea';
import Info from '../../../../assets/img/icons/Info.svg';
import KeywordSourceV2 from './KeywordSourceV2';
import { DYNAMIC_AUDIENCE_MATCHING } from 'constants/actionTypes';
import ImportListFlow from 'modules/Campaigns/Audience/Import/importListFlow';
import SearchTerm from 'modules/Content/Search/Components/SearchTerm';

type CreateAssetAsiderProps = {
  templateAsider: boolean;
  campaignItems: ICampaignsName[];
  selectedCampaign: number;
  handleSelectedCampaign?: any;
  onClickCancel?: any;
  onClickCreateCampaign?: any;
  showTemplatesBrowser?: any;
  setToggleAssetNameEdit?: any;
  setAssetName?: any;
  selectedTemplateName: string;
  assetName: string;
  selectedTemplateImage: string;
  toggleAssetNameEdit: string;
  toggleDisable: string;
  selectedTemplateId: number;
  setToggleDisabled?: any;
  handleAdhocNameInput?: any;
  showCampaignAsider?: boolean;
  handleCampaignName?: any;
  handleOnClickBrowsePeople?: any;
  onClickAudienceDone?: any;
  setSelectedContactNames?: (value: any[]) => void;
  setSelectedContactIds?: (value: any[]) => void;
  selectedContactNames?: string[];
  selectedContactIds?: any[];
  setSelectedListIds?: (value: any[]) => void;
  setSelectedListNames?: (value: any[]) => void;
  setCreateAdHocAsset: (value: boolean) => void;
  selectedListNames?: string[];
  selectedListIds?: any[];
  handleAddPeople?: any;
  campaignKeywords?: any[];
  setCampaignKeywords?: any;
  handleOnRemoveCampaignKeyword?: any;
  handleAddSearchTerm?: any;
  campaignName?: any;
  assetType?: any;
  loadMore?: any;
  loadingCampaigns?: boolean;
  handleSearchCampaign?: (value: string) => void;
  assetId?: string;
  showCreateAdHocAsset?: boolean;
  showAudienceAsider?: boolean;
  eventType?: string;
  sendToField?: any;
  sendToEmails?: string[];
  showImportListAsider?: boolean;
  setShowImportListAsider?: (value: boolean) => void;
};

const CreateAssetAsider: React.FC<CreateAssetAsiderProps> = (props: CreateAssetAsiderProps) => {
  const {
    campaignItems,
    selectedCampaign,
    handleSelectedCampaign,
    onClickCreateCampaign,
    onClickCancel,
    showTemplatesBrowser,
    selectedTemplateName,
    selectedTemplateImage,
    assetName,
    toggleAssetNameEdit,
    toggleDisable,
    selectedTemplateId,
    campaignName,
    handleAdhocNameInput,
    showCampaignAsider,
    handleCampaignName,
    handleOnClickBrowsePeople,
    selectedListIds,
    selectedListNames,
    handleAddPeople,
    campaignKeywords,
    setCampaignKeywords,
    handleOnRemoveCampaignKeyword,
    assetType,
    selectedContactNames,
    selectedContactIds,
    setCreateAdHocAsset,
    loadMore,
    loadingCampaigns,
    handleSearchCampaign,
    showCreateAdHocAsset,
    assetId,
    showAudienceAsider,
    eventType,
    sendToField,
    sendToEmails,
    showImportListAsider,
    setShowImportListAsider,
  } = props;
  const history = useHistory();
  const [prompt, setPrompt] = useState('');
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const [disableGenerate, setDisableGenerate] = useState(true);
  const [dynamicAudienceKeywords, setDynamicAudienceKeywords]: any[] = useState([]);
  const redirectUrl = useSelector((state: RootState) => state.adHocTemplates.redirectUrl);
  const recommendedPeopleSearchTerm = useSelector((state: RootState) => state.recommendedPeople.searchTerm);
  const aiInputPrompt = useSelector((state: RootState) => state.aiEmail.prompt);
  const isAIEmail = assetType === AssetType.AI_EMAIL;
  useAutosizeTextArea(textAreaRef.current, prompt);

  function saveAdHocAsset() {
    // Save selected template with asset
    if (showCampaignAsider) {
      saveAdHocAssetAPIAndCampaign(assetName, campaignName, campaignKeywords, selectedContactIds, selectedListIds, selectedTemplateId);
    } else {
      saveAdHocAssetAPI(selectedCampaign, assetName, selectedTemplateId);
    }
  }

  const generateClickHandle = () => {
    setAiContacts([]);
    setInputPrompt('');
    saveAIEmailAssetAPIAndCampaign(
      assetName,
      campaignName,
      selectedCampaign,
      prompt.trim(),
      eventType ?? '',
      selectedContactIds,
      selectedListIds,
      sendToEmails,
    );
  };

  useEffect(() => {
    if (aiInputPrompt) {
      setPrompt(aiInputPrompt);
    }
  }, []);

  useEffect(() => {
    if (dynamicAudienceKeywords && dynamicAudienceKeywords.length > 0 && recommendedPeopleSearchTerm) {
      dynamicAudienceSearch(0, 50, recommendedPeopleSearchTerm, dynamicAudienceKeywords.join(','), false, '', []);
      searchLists(dynamicAudienceKeywords.join(','), dynamicAudienceKeywords.length > 0, 0, 100);
      store.dispatch({
        type: DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS,
        dynamicKeywords: dynamicAudienceKeywords,
      });
    } else if (dynamicAudienceKeywords && dynamicAudienceKeywords.length > 0 && !recommendedPeopleSearchTerm) {
      dynamicAudienceSearch(0, 50, '', dynamicAudienceKeywords.join(','), false, '', []);
      searchLists(dynamicAudienceKeywords.join(','), dynamicAudienceKeywords.length > 0, 0, 100);
      store.dispatch({
        type: DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS,
        dynamicKeywords: dynamicAudienceKeywords,
      });
    } else if (!dynamicAudienceKeywords || (dynamicAudienceKeywords.length === 0 && recommendedPeopleSearchTerm)) {
      searchPeople(0, 50, recommendedPeopleSearchTerm, false);
      getRecommendedLists(0, 100);
    }
  }, [dynamicAudienceKeywords]);

  useEffect(() => {
    if (redirectUrl) {
      let url = redirectUrl;
      store.dispatch({
        type: ADHOC.RESET_URL,
        redirectUrl: '',
      });
      history.push(url);
      closeOverlay();
      setCreateAdHocAsset(false);
    }
  }, [redirectUrl]);

  useEffect(() => {
    if (isAIEmail && prompt.trim() && assetName.trim() && (selectedCampaign || (showCampaignAsider && campaignName))) {
      setDisableGenerate(false);
    } else {
      setDisableGenerate(true);
    }
  }, [prompt, assetName, selectedCampaign, campaignName]);

  const handleChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
    const val = evt.target?.value;
    setPrompt(val);
  };

  const handleAiCancelClick = () => {
    onClickCancel();
    setPrompt('');
  };

  const addDynamicAudienceKeyword = (keyword: string) => {
    if (keyword.trim() !== '') {
      if (keyword.includes(',')) {
        const keywordArr = keyword.split(',').filter((item: string) => {
          if (item.trim() !== '') return item.toLowerCase().trim().replace(' and ', ' AND ');
        });
        if (dynamicAudienceKeywords && dynamicAudienceKeywords.length > 0) {
          const newKeywordArr = dynamicAudienceKeywords;
          keywordArr.map((item: string) => {
            if (!dynamicAudienceKeywords.includes(item)) {
              newKeywordArr.push(item);
            }
          });
          setDynamicAudienceKeywords([...new Set(newKeywordArr)]);
        } else {
          let uniqueKeywordsArray = [...new Set(keywordArr)];
          setDynamicAudienceKeywords(uniqueKeywordsArray);
        }
      } else {
        if (dynamicAudienceKeywords && dynamicAudienceKeywords.length > 0) {
          if (!dynamicAudienceKeywords.includes(keyword.toLowerCase().trim())) {
            setDynamicAudienceKeywords([...dynamicAudienceKeywords, keyword.toLowerCase().trim().replace(' and ', ' AND ')]);
          }
        } else {
          setDynamicAudienceKeywords([keyword.toLowerCase().trim().replace(' and ', ' AND ')]);
        }
      }
    }
  };

  const removeDynamicAudienceKeyword = (keyword: string) => {
    const newKeywords = dynamicAudienceKeywords?.filter((item: string) => item !== keyword);
    setDynamicAudienceKeywords(newKeywords);
    if (newKeywords.length === 0) {
      store.dispatch({
        type: DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS,
        dynamicKeywords: [],
      });
      if (!recommendedPeopleSearchTerm) {
        getRecommendedPeople(0, 50);
        getRecommendedLists(0, 100);
      } else {
        searchPeople(0, 50, recommendedPeopleSearchTerm, false);
        getRecommendedLists(0, 100);
      }
    }
  };

  return (
    <>
      <Wrapper className={classNames('wrapper-campaign-keyword open', { AiCreatedEmail: isAIEmail })} isAIEmail={isAIEmail}>
        {isAIEmail ? <CloseIconDrawer onClick={handleAiCancelClick} /> : null}
        <div className="create-campaign-wrapper-two">
          <h1 className="create-campaign-heading">
            {isAIEmail ? (
              <>
                Generate new <br /> AI Email{' '}
              </>
            ) : (
              <>
                Create New
                <br />
                Email
              </>
            )}
          </h1>
          <div className="scroll-Wrapper-two">
            <div className={`edit-wrapper-two ${toggleAssetNameEdit}`}>
              {/* Toggle editable-active class */}
              <span className="name-two">
                <h2 id="asset_name" className="asset-name-two new-campaign">
                  {'Name your new email *'}
                </h2>
                <div className="editable">
                  <Input
                    type="text"
                    label="Name your new Email *"
                    placeholder="Give your email a name"
                    onChange={(e: any) => handleAdhocNameInput(e, 'name')}
                    value={assetName}
                    idInput="email-name-input-adhoc"
                  />
                </div>
              </span>
            </div>
            {!isAIEmail ? (
              <>
                <KeywordSource
                  heading="Select a template for this Ad hoc email *"
                  showInput={false}
                  placeholder=""
                  desc=""
                  className="newAdhocEmailAsider"
                >
                  <span className="test" onClick={showTemplatesBrowser} id="browse-adhoc-templates">
                    Browse
                  </span>
                </KeywordSource>
                <div className="template-row align-items-center d-flex py-3">
                  <div>
                    <img src={selectedTemplateImage !== '' ? selectedTemplateImage : Temp} alt="" />
                  </div>
                  <div className="ps-3 text-desc">
                    <h4 className="main-title" id="selected-template-name">
                      {selectedTemplateName !== '' ? selectedTemplateName : 'No template selected'}
                    </h4>
                    <p>
                      Click Browse above to view our pre-built templates, your custom templates, and templates shared with you. You can also create
                      your own template from scratch…
                    </p>
                  </div>
                </div>
              </>
            ) : null}

            <Row gutter={26} className="mt-4">
              <Col className="gutter-row py-3" span={24}>
                <h4 className="main-title mb-1">Save email to a campaign *</h4>
                <CustomSelectAsset
                  campaigns_list={campaignItems}
                  campaignName={'Please select...'}
                  selectedValue={
                    showCampaignAsider
                      ? 'Create new campaign'
                      : campaignItems?.find((item) => selectedCampaign?.toString() === item?.campaign_id?.toString())?.name
                  }
                  setCampaignName={(value: string) => {
                    'user';
                  }}
                  setSelectedCampaign={handleSelectedCampaign}
                  onClickCreateCampaign={(value: any) => {
                    onClickCreateCampaign(value);
                  }}
                  loadMore={() => loadMore && loadMore()}
                  loadingCampaigns={loadingCampaigns}
                  handleSearchCampaign={handleSearchCampaign}
                  isCampaignDropDown={true}
                  showAssetAsider={showCreateAdHocAsset}
                  paginationId={'adhoc' + assetId ?? assetId}
                  showCampaignAsider={showCampaignAsider}
                />
              </Col>
            </Row>
            {showCampaignAsider ? (
              <div className="new-campaign-bottom">
                <NewCampaignModule
                  handleCampaignNameInput={handleCampaignName}
                  campaignName={campaignName}
                  handleOnClickBrowsePeople={handleOnClickBrowsePeople}
                  selectedContactIds={selectedContactIds}
                  selectedContactNames={selectedContactNames}
                  selectedListIds={selectedListIds}
                  selectedListNames={selectedListNames}
                  handleAddPeople={handleAddPeople}
                  handleOnRemoveCampaignKeyword={handleOnRemoveCampaignKeyword}
                  campaignKeywords={campaignKeywords}
                  setCampaignKeywords={setCampaignKeywords}
                  assetType={assetType}
                  saveAsAsset={false}
                  showCampaignAsider={showCampaignAsider}
                  showAudienceAsider={showAudienceAsider}
                />
              </div>
            ) : null}
            {isAIEmail ? (
              showCampaignAsider ? (
                <>
                  {/* <div className={`input-with-upload input-box dynamicAudienceField`}>
                  <div className="d-flex align-items-center justify-content-between">
                    <label className="publish-label">
                      Dynamic audience matching
                    </label>
                  </div>
                  <KeywordSourceV2
                    hideTopWrapper
                    heading=""
                    placeholder={`Start typing Keywords and separated by “,” comma`}
                    desc="Our Recommendation Engine finds the best matching contacts for your emails based on the added keywords"
                    marginTop="10px"
                    marginBottom="20px"
                    searchTerms={dynamicAudienceKeywords}
                    handleAddSearchTerm={addDynamicAudienceKeyword}
                    handleOnRemove={removeDynamicAudienceKeyword}
                    inNewListAsider={true}
                    idprefix={"publish-idprefix"}
                    firstKeyPressed={showAudienceAsider}
                    onKeyPressOpen={() => handleOnClickBrowsePeople()}
                  />
                </div> */}
                </>
              ) : (
                <>
                  {/* {sendToField()} */}
                  {/* <div className={`input-with-upload input-box dynamicAudienceField`}>
                  <div className="d-flex align-items-center justify-content-between">
                    <h4 className="publish-label" >
                      Dynamic audience matching
                    </h4>
                  </div>
                  <KeywordSourceV2
                    hideTopWrapper
                    heading=""
                    placeholder={`Start typing Keywords and separated by “,” comma`}
                    desc="Our Recommendation Engine finds the best matching contacts for your emails based on the added keywords"
                    marginTop="10px"
                    marginBottom="20px"
                    searchTerms={dynamicAudienceKeywords}
                    handleAddSearchTerm={addDynamicAudienceKeyword}
                    handleOnRemove={removeDynamicAudienceKeyword}
                    inNewListAsider={true}
                    idprefix={"publish-idprefix"}
                    firstKeyPressed={showAudienceAsider}
                    onKeyPressOpen={() => handleOnClickBrowsePeople()}
                  />
                </div> */}
                  {/* <div className="relative-input">
                    <span className="browse" onClick={handleOnClickBrowsePeople}>
                      Browse
                    </span>

                    <Input
                      label="Select email audience *"
                      placeholder="Please select"
                      className={`select-email-aud disabled ${selectedContactNames?.length === 0 && selectedListIds?.length === 0 ? '' : 'd-none'}`} // for hiding input field
                    />
                    {(selectedContactNames && selectedContactIds && selectedContactNames.length > 0) ||
                    (selectedListNames && selectedListIds && selectedListNames.length > 0) ? (
                      <ScrollSpaceControl>
                        <ContactDetailsDashboard
                          className={classNames('holder-for-audience scrollStyle', {
                            newAiEmail: selectedContactNames?.length !== 0 && selectedListIds?.length !== 0,
                          })}
                        >
                          {selectedListNames && selectedListIds && selectedListNames.length > 0 ? (
                            <div className="contact-list-name">
                              {selectedListNames.map((name: any, index: number) => {
                                return (
                                  <SearchTerm
                                    key={index}
                                    hideSearchIcon={true}
                                    searchTerm={name}
                                    onRemove={() => handleAddPeople(selectedListIds[index], name, 'list')}
                                    isExtended={true}
                                    showIcon
                                  />
                                );
                              })}
                            </div>
                          ) : null}
                          {selectedContactNames && selectedContactIds && selectedContactNames.length > 0 ? (
                            <div className="contact-person-names">
                              {selectedContactNames.map((name: any, index: number) => {
                                return (
                                  <SearchTerm
                                    key={index}
                                    hideSearchIcon={true}
                                    searchTerm={name}
                                    onRemove={() => handleAddPeople(selectedContactIds[index], name, 'contact')}
                                    typeSearch
                                    isExtended={true}
                                    showIcon
                                  />
                                );
                              })}
                            </div>
                          ) : null}
                        </ContactDetailsDashboard>
                      </ScrollSpaceControl>
                    ) : null}
                  </div> */}
                </>
              )
            ) : null}
          </div>
        </div>
        <FooterActionButton footerStyle={`${isAIEmail ? 'footer-style' : ''}`}>
          {isAIEmail ? (
            <FooterGpt className="footer-ai-generated">
              <h3 className="asset-name-two new-campaign">
                <GillRoyBotIcon />
                Please tell
                <span style={{ color: '#1EC252' }}> Gilroy </span>
                what your email is about *
                <span className="infoTooltip">
                  <Popover
                    trigger="hover"
                    placement="bottom"
                    overlayClassName="info-tooltip tooltip-for-ai-email"
                    content="Please provide prompt for email generation"
                    getPopupContainer={() => document.querySelectorAll(`.footer-ai-generated`)[0] as HTMLElement}
                  >
                    <img src={Info} alt="info-icon" className="info-icon" />
                  </Popover>
                </span>
              </h3>
              <TextArea>
                <textarea
                  id="review-text"
                  onChange={handleChange}
                  placeholder="Type a message..."
                  ref={textAreaRef}
                  rows={1}
                  value={prompt}
                  className="textarea-input text-prompt-js"
                  maxLength={5000}
                />
              </TextArea>
              <span className={`${disableGenerate ? 'disabled' : ''} icon-btn`} onClick={generateClickHandle}>
                <GillRoyBotIcon color="#fff" />
                Generate
              </span>
            </FooterGpt>
          ) : (
            <>
              <span className="footer-btn mr" onClick={onClickCancel} id="cancel-email-adhoc">
                Cancel
              </span>
              <span className={`footer-btn filled-success ${toggleDisable}`} onClick={saveAdHocAsset} id="save-email-adhoc">
                Save
              </span>
            </>
          )}
        </FooterActionButton>
      </Wrapper>
      <ImportListFlow
        inPublishEmail={false}
        showImportListAsider={showImportListAsider!}
        setShowImportListAsider={setShowImportListAsider}
        handleAddPeople={handleAddPeople}
        showCompleteImport={false}
      />
    </>
  );
};

export default React.memo(CreateAssetAsider);

const TextArea = styled.div`
  position: relative;
  height: 145px;
  .textarea-input {
    border-radius: 8px;
    border: 1px solid #dadada;
    padding: 8px 30px 8px 15px;
    width: 100%;
    overflow: hidden;
    resize: none;
    font-family: 'Roboto Slab';
    color: #7e7e7e;
    font-style: normal;
    max-height: 140px !important;
    min-height: 140px; // because of reason do not remove it
    &.maxOverflow {
      ${scrollbar}
      ::-webkit-scrollbar {
        width: 17px;
      }
      ::-webkit-scrollbar-track {
        background-color: transparent;
      }
      ::-webkit-scrollbar-thumb {
        background-color: #001760;
        border-radius: 20px;
        border: 7px solid transparent;
        background-clip: content-box;
      }
    }

    &.removeOverFlow {
      overflow: hidden !important;
    }

    &::placeholder {
      font-style: italic;
      font-family: 'Roboto';
      font-weight: 400;
      color: #cacaca;
    }

    &:focus-visible {
      outline: none;
    }
  }

  svg {
    position: absolute;
    right: 15px;
    bottom: 17px;
    cursor: pointer;
  }
  grammarly-extension {
    display: none;
  }
`;
const FooterGpt = styled.div`
  h3 {
    color: #5e7079;
    font-family: 'Roboto';
    font-size: 14px;
    font-weight: 600;
  }
  .infoTooltip {
    z-index: 1;
    position: relative;
    img {
      width: 13px;
      margin-left: 3px;
      margin-right: 2px;
    }
  }
  &.footer-ai-generated {
    background: #fff;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.16);
    width: 100%;
    padding: 12px 62px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    background-color: #fff;
    z-index: 9;
    display: flex;
    flex-direction: column;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 12px 40px;
    }
    .icon-btn {
      margin-top: 16px;
      font-size: 16px;
      background-color: #1ec252;
      color: #fff;
      padding: 2px 14px;
      font-family: Roboto;
      font-weight: 500;
      border-radius: 8px;
      cursor: pointer;
      text-transform: capitalize;
      width: 100%;
      display: block;
      text-align: center;
      margin-top: 0px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 14px;
      }
      &.disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    }
  }
`;

const ScrollSpaceControl = styled.div`
  padding-top: 5px;
  padding-right: 5px;
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #ccc;
`;

const ContactDetailsDashboard = styled.div`
  max-height: 160px;
  overflow-y: auto;
  padding: 0px 6px 6px 6px;
`;

const Wrapper = styled.div<{ isAIEmail?: boolean }>`
  transition: ease all 0.1s;
  box-sizing: border-box;
  height: 100vh;
  overflow-y: auto;
  width: 0px;
  background-color: #fff;
  position: relative;
  min-width: 100%;
  transition: ease all 0.1s;
  overflow: hidden;
  padding: 42px 40px 29px 40px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 30px 20px 30px 20px;
  }
  &.open {
    max-width: 530px;
    width: 100%;
    transition: ease all 0.1s;
    overflow: hidden;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-width: 410px;
    }
  }
  @media all and (max-height: 1439px) and (min-height: 600px) {
    justify-content: space-between;
    align-items: center;
    .btn-wrapper {
      display: flex;
      align-items: center;
      .ml {
        margin-left: 12px;
      }
    }
  }
  &.AiCreatedEmail {
    // area for ai email
    .create-campaign-wrapper-two {
      .edit-wrapper-two {
        margin-bottom: 30px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-bottom: 15px;
        }
      }
      .relative-input {
        .browse {
          top: 0px;
          right: 1px;
        }
        .import {
          top: 0px;
          right: 70px;
        }
        label {
          margin-top: 0px;
        }
      }
      .new-campaign-bottom {
        .newCampaignModule {
          margin-top: -10px;
          margin-bottom: 0px;
        }
      }
    }
    .holder-for-audience {
      &.newAiEmail {
        display: flex;
        flex-direction: column;
      }
    }
  }
  .sendToSelectBox {
    background-color: #def6e6;
    border-top-left-radius: 13px;
    border-top-right-radius: 13px;
  }
  .sendToSelectBox > .ant-select-selector {
    max-height: 180px;
    /* height: 32px !important; */
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    /* padding: 4px 12px !important; */
    padding: 7px 15px;
    height: auto;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 7px 12px;
      border-radius: 6px;
      font-size: 12px;
      margin-top: 2px;
      line-height: 16px;
    }
    .ant-select-selection-item {
      color: #7e7e7e;
      font-size: 16px;
      font-weight: 600;
      font-family: 'robotoregular';
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
        line-height: 16px;
      }
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-bottom: 4px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
      border-radius: 3px;
    }
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-top: 0 !important;
    }
  }
  .sendToSelectBox {
    .ant-tag {
      & > span:nth-child(1) {
        display: flex;
        align-items: center;
      }
      .contact-icon {
        display: flex;
      }
    }
    .ant-select-selection-placeholder {
      left: 13px;
      @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        left: 12px;
      }
    }
  }
  .ant-select-dropdown {
    /* display: none; */
    box-shadow: 0 7px 14px -9px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.08), 0 0px 0px 0px rgba(0, 0, 0, 0.05);
  }
  .ant-select-item-option-content {
    display: flex;
    justify-content: space-between;
    .dropdownValue {
      margin-bottom: 0;
      /* max-width: 75%; */
    }
    .disabled {
      opacity: 0.4;
    }
  }
  .footer-style {
    display: block !important;
  }
  .template-row {
    .text-desc {
      @media all and (min-width: 1439px) {
        padding-right: 55px;
      }
    }
    img {
      max-width: 100%;
      min-width: 100px;
    }
    h4.main-title {
      font-family: 'Roboto Slab', serif;
      font-weight: 500;
      color: #5e7079 !important;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
      }
    }
    p {
      color: #5e7079;
      font-size: 14px;
      font-weight: 400;
      font-family: 'Roboto', sans-serif;
      margin: 0;
      white-space: pre-wrap;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 10px;
      }
    }
  }
  .dec-paragraph.mb {
    margin: 8px 0 10px 0 !important;
  }
  .main-title {
    color: #5e7079 !important;
    font-size: 18px;
    font-weight: 500;
    font-family: 'Roboto', sans-serif;
    margin: 0;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  .select-dropdown {
    width: 100%;
    .ant-select-selector {
      border: 1px solid #dadada;
      border-radius: 8px;
      background-color: #fff;
      color: #7e7e7e;
      font-family: 'Roboto', sans-serif;
      font-size: 16px;
      font-weight: 500;
      padding: 5px 13px;
      width: 100%;
      margin-top: 6px;
    }
    .ant-select-arrow {
      background-image: url(${DownAngle});
      background-repeat: no-repeat;
      background-position: 8px 8px;
      border-left: 1px solid #dddddd;
      padding-left: 10px;
      margin-left: 10px;
      min-width: 22px;
      min-height: 22px;
      vertical-align: 0;
      top: 40%;
      span {
        opacity: 0;
      }
    }
  }
  .asset-name-two {
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    float: left;
    max-width: 700px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-width: 445px;
    }
  }
  .name-two {
    color: rgb(155, 155, 155);
    position: relative;
    float: left;
    display: flex;
    align-items: center;
    width: 100%;
    .tooltip {
      position: relative;
      display: inline-block;
      opacity: 1;
      z-index: 0;
      .tooltiptext {
        color: #ffffff;
        font-size: 11px;
        letter-spacing: 0.02px;
        line-height: 15px;
        text-align: center;
        background-color: #263153;
        visibility: hidden;
        border-radius: 4px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;
        transition: opacity 0.3s;
        padding: 5px 10px;
        &:after {
          content: '';
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #263153 transparent transparent transparent;
        }
      }
      &:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
      }
    }
    .asset-name-two {
      text-overflow: ellipsis;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      float: left;
      max-width: 700px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: 445px;
      }
    }
    &.editable-active {
      .editable {
        display: block;
      }
    }
    .editable {
      position: absolute;
      top: 45px;
      left: 0;
      width: 100%;
      display: none;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        top: 25px;
      }
      label {
        display: none;
      }
      input {
        padding-right: 70px;
      }
      .save {
        position: absolute;
        top: 9px;
        right: 10px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
        }
      }
      .cancel {
        position: absolute;
        top: 9px;
        right: 40px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
          padding: 2px;
        }
      }
    }
    .edit-btn {
      cursor: pointer;
      margin-left: 10px;
    }
  }
  .scroll-Wrapper-two {
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: ${(props) => (props.isAIEmail ? 'calc(100% - 310px)' : '510px')};
    @media (min-height: 730px) {
      height: ${(props) => (props.isAIEmail ? 'calc(100% - 330px)' : 'calc(100% - 140px)')};
    }
    @media (min-width: 1920px) and (-webkit-device-pixel-ratio: 1) {
      height: ${(props) => (props.isAIEmail ? '500px' : '690px')};
    }
    @media (max-width: 1366px) {
      height: ${(props) => (props.isAIEmail ? 'calc(100% - 310px)' : 'calc(100% - 110px)')};
    }
    .search-terms-wrap {
      .wrapper-content {
        flex-direction: row;
        align-items: baseline;
      }
    }
    ::-webkit-scrollbar {
      display: none;
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
  }
  .closeSvgIcon {
    position: absolute;
    right: 20px;
    top: 0px;
    width: 30px;
    cursor: pointer;
  }
  .input-with-upload {
    .ant-tag {
      white-space: nowrap;
      word-break: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      justify-content: start;
      display: block !important;
      padding-right: 25px !important;
      position: relative;
      .icon-cross {
        position: absolute;
        right: 5px;
        top: 2px;
        z-index: 3;
      }
      .edit-option {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -2;
        opacity: 0;
        visibility: hidden;
        background-color: #696969;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        display: block;
        width: 100%;
        font-family: 'Roboto', sans-serif;
        padding: 3px 0;
        transition: 0.5s;
        padding-right: 12px;
        svg {
          margin-right: 5px;
          vertical-align: baseline;
        }
      }
      .list-item {
        &:hover {
          .edit-option {
            opacity: 0.9;
            visibility: visible;
            z-index: 2;
          }
          .icon-cross {
            transition: 0.5s;
            svg {
              circle {
                transition: 0.5s;
                fill: #fff;
              }
            }
            polygon {
              transition: 0.5s;
              fill: #696969;
            }
          }
        }
      }
    }

    &.contact-selected {
      .ant-select-selector {
        padding-bottom: 15px !important;
      }
    }
  }
  .dynamicAudienceField {
    div > .add-words-wrapper {
      padding-bottom: 0 !important;
    }
    div > .add-words-wrapper > .dec-paragraph.mb {
      margin-bottom: 0;
    }
    div > .publish-label {
      padding-bottom: 0;
    }
    .wrapper-tags {
      & > div:nth-child(3) {
        height: 40px !important;
        @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          height: 26px !important;
        }
        .search-input {
          padding: 10px 13px;
          line-height: 22px;
          @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding: 3px 12px;
            line-height: 22px;
          }
        }
      }
    }
  }
  .input-box {
    .publish-label {
      color: #5e7079;
      display: block;
      margin: 23px 0 8px 0;
      font-size: 18px;
      font-family: Roboto, sans-serif;
      font-weight: 500;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 14px;
      }
    }
  }
  .create-campaign-wrapper-two {
    position: relative;
    height: 100%;

    .create-campaign-heading {
      color: #424b50;
      font-size: 46px;
      font-weight: 500;
      line-height: 48px;
      margin-bottom: 0px;
      display: block;
      font-family: 'Roboto Slab', serif;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 32px;
        line-height: 40px;
      }
    }
    .edit-wrapper-two {
      display: flex;
      margin-top: 20px;
      margin-bottom: 65px;
      padding: 0 2px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 10px;
        margin-bottom: 50px;
      }
      .new-campaign {
        color: #5e7079;
        font-size: 20px;
        line-height: 47px;
        margin-bottom: 0px;
        display: inline-block;
        font-family: 'Roboto', sans-serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 14px;
          line-height: 24px;
        }
      }
      .edit-icon {
        margin-left: 10px;
        cursor: pointer;
      }
      &.editable-active {
        .editable {
          display: block;
        }
      }
    }
  }
  .newAdhocEmailAsider {
    .add-word-head {
      @media all and (min-width: 1440px) {
        width: calc(100% - 20px);
      }
    }
  }
  .relative-input {
    position: relative;
    float: left;
    display: block;
    width: 100%;
    .browse {
      font-family: 'Roboto';
      font-weight: 700;
      font-size: 12px;
      color: #1ec252;
      border: 1px solid #1ec252;
      padding: 2px 8px;
      border-radius: 6px;
      cursor: pointer;
      letter-spacing: 1px;
      position: absolute;
      right: 0;
      top: 22px;
      width: auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 9px;
        border-radius: 4px;
      }
    }
    input {
      margin-bottom: 0;
    }
  }
  .list-contact-box {
    order: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px;
    display: flex;
    flex-direction: column;
  }
`;
